import { defineStore } from 'pinia'
const useStore = defineStore('store', {
    state: () => {
        return {
            // 基本信息
            basicInfo:{
                '所属电厂':'漫湾电厂',
                '装机容量':'480MW',
                '品牌型号':'东方电气 OS4-ZLS-O-S',
                '投产时间':'2020-05-05',
            },
            // 机组类型
            unitType:{
                name:'机组类型',
                data:['混流式','轴流式','机组拆卸','装配组合'],
            },
            // 发电量
            powerGeneration:{
                name:'发电统计',
                data:[
                  {
                    title:'每日',
                    option:{
                      grid: {
                          left: '0%',
                          right: '0%',
                          bottom: '0%',
                          top: '0%',
                      },
                      title: {
                        show: true,
                        text: `1253.21\n千瓦时`,
                        x: "center",
                        y: "center",// 通过x,y将标题(进度)定位在圆环中心
                        textStyle: {
                          color: "white",
                          fontWeight: "400",
                          fontFamily: "PangMenZhengDao",
                          fontSize:14
                        },
                      },
                      series: [
                        // 边框
                        {
                          type: 'pie',
                          radius: ['100%', '99%'],
                          center: ['50%', '50%'],
                          hoverAnimation: false, // 鼠标移入变大
                          startAngle: 225,
                          labelLine: {
                            show: false
                          },
                          label: {
                            position: 'center'
                          },
                          data: [100],
                          color: ['rgba(255,255,255,.2)']
                        },
                      {
                        type: 'pie',
                        zlevel: 3,
                        silent: true,
                        radius: ['80%', '70%'],
                        center: ['50%', '50%'],
                        label: {
                            normal: {
                                show: false
                            },
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: (function(){
                            let dataArr = [];
                            let total = 100;
                            let datevalue = 50 / total;
                            for (var i = 0; i < 36; i++) {
                                if (i % 2 === 0) {
                                   //  带颜色的圈
                                    if (i<36-Math.round(36*datevalue)){
                                        dataArr.push({
                                            name: (i + 1).toString(),
                                            value: 2.5,
                                            itemStyle: {
                                                normal: {
                                                    color: "#676a6c",
                                                    borderWidth: 2,
                                                    borderColor: "#676a6c",
                                                    borderRadius:[12,12,12,12]
                                                },
                                            }
                                        })
                                    }else{
                                        dataArr.push({
                                            name: (i + 1).toString(),
                                            value: 2.5,
                                            itemStyle: {
                                                normal: {
                                                    color: "#64f4ff",
                                                    borderWidth: 2,
                                                    borderColor: "#64f4ff",
                                                    borderRadius:[12,12,12,12]
                                                },
                                               //  barBorderRadius:[1,1,1,1]
                                            }
                                        })
                                    }
                                } else {
                                    dataArr.push({
                                        name: (i + 1).toString(),
                                        value: 3,
                                        itemStyle: {
                                            normal: {
                                                color: "rgba(0,0,0,0)",
                                                borderWidth: 0,
                                                borderColor: "rgba(0,0,0,0)"
                                            }
                                        }
                                    })
                                }
                       
                            }
                            return dataArr
                        })()
                    }
                    ],
                  }
                  },
                    {
                        title:'每月',
                        option:{
                            title: {
                              show: true,
                              text: `1253.21\n千瓦时`,
                              x: "center",
                              y: "center",// 通过x,y将标题(进度)定位在圆环中心
                              textStyle: {
                                color: "white",
                                fontWeight: "400",
                                fontFamily: "PangMenZhengDao",
                                fontSize:14
                              },
                            },
                            tooltip: {
                              trigger: "item",
                              formatter: "{d}%",
                              show: true,
                            },
                            legend: {
                              orient: "vertical",
                              x: "left",
                              show: false,
                            },
                            grid: {
                              // show: true,
                              top: '0%',
                              left: '0%',
                              right: '0%',
                              bottom: '0%',
                              containLabel: true
                            },
                            series: [{
                              name: "",
                              type: "pie",
                              radius: ["60%", "80%"],
                              avoidLabelOverlap: true,
                              hoverAnimation: false,
                              label: {
                                normal: {
                                  show: false,
                                  position: "center",
                                },
                                emphasis: {
                                  show: false,
                                },
                              },
                              labelLine: {
                                normal: {
                                  show: false,
                                },
                              },
                              data: [
                                {
                                  value: 100 - 60,
                                  name: "",
                                  itemStyle: {
                                    color: "rgb(10, 49, 44)",//透明色，也可以设置把其他颜色
                                  },
                                },
                                {
                                  value: 60,
                                  name: "",
                                  itemStyle: {
                                    color: "rgb(0, 255, 126)",
                                  },
                                }
                              ],
                            },
                            {
                              type: 'pie',
                              radius: ['100%', '99%'],
                              center: ['50%', '50%'],
                              hoverAnimation: false, // 鼠标移入变大
                              startAngle: 225,
                              labelLine: {
                                show: false
                              },
                              label: {
                                position: 'center'
                              },
                              data: [100],
                              color: ['rgba(255,255,255,.2)']
                            }
                          ],
                          }
                    },
                    {
                        title:'今年',
                        option:{
                            title: {
                              show: true,
                              text: `1253.21\n千瓦时`,
                              x: "center",
                              y: "center",// 通过x,y将标题(进度)定位在圆环中心
                              textStyle: {
                                color: "white",
                                fontWeight: "400",
                                fontFamily: "PangMenZhengDao",
                                fontSize:14
                              },
                            },
                            grid: {
                              // show: true,
                              top: '0%',
                              left: '0%',
                              right: '0%',
                              bottom: '0%',
                              containLabel: true
                            },
                            series: [
                              {
                                name: '',
                                type: 'gauge',
                                radius: '120%', //  显示成一个环形 // 和占比环重合
                                center: ['50%', '50%'],
                                startAngle: 179.9999,
                                endAngle: 179.9999,
                                splitNumber: 40, // 分成20个小分隔
                                hoverAnimation: true,
                                axisTick: {
                                  show: false
                                },
                                splitLine: {
                                  length: 12,
                                  lineStyle: {
                                    width: 2,
                                    color: 'rgb(24, 48, 63)'
                                  }
                                },
                                axisLabel: {
                                  show: false
                                },
                                pointer: {
                                  show: false
                                },
                                axisLine: {
                                  lineStyle: {
                                    opacity: 0
                                  }
                                },
                                detail: {
                                  show: false
                                },
                                
                              },
                              {
                                name: '',
                                type: 'gauge',
                                radius: '120%', //  显示成一个环形 // 和占比环重合
                                center: ['50%', '50%'],
                                startAngle: 270,
                                endAngle: 90,
                                splitNumber: 20, // 分成20个小分隔
                                hoverAnimation: true,
                                axisTick: {
                                  show: false
                                },
                                splitLine: {
                                  length: 12,
                                  lineStyle: {
                                    width: 2,
                                    color: 'rgb(20, 160, 218)'
                                  }
                                },
                                axisLabel: {
                                  show: false
                                },
                                pointer: {
                                  show: false
                                },
                                axisLine: {
                                  lineStyle: {
                                    opacity: 0
                                  }
                                },
                                detail: {
                                  show: false
                                },
                                
                              },
                            //   外圆线
                              {
                                type: 'pie',
                                radius: ['100%', '98%'],
                                center: ['50%', '50%'],
                                hoverAnimation: false, // 鼠标移入变大
                                startAngle: 225,
                                labelLine: {
                                  show: false
                                },
                                label: {
                                  position: 'center'
                                },
                                data: [100],
                                color: ['rgba(255,255,255,.2)']
                              }
                            ]
                          }
                    },
                    {
                      title:'累计',
                      option:{
                          title: {
                            show: true,
                            text: `1253.21\n千瓦时`,
                            x: "center",
                            y: "center",// 通过x,y将标题(进度)定位在圆环中心
                            textStyle: {
                              color: "white",
                              fontWeight: "400",
                              fontFamily: "PangMenZhengDao",
                              fontSize:14
                            },
                          },
                          grid: {
                            // show: true,
                            top: '0%',
                            left: '0%',
                            right: '0%',
                            bottom: '0%',
                            containLabel: true
                          },
                          series: [
                            {
                              name: '',
                              type: 'gauge',
                              radius: '120%', //  显示成一个环形 // 和占比环重合
                              center: ['50%', '50%'],
                              startAngle: 90,
                              endAngle: 91,
                              splitNumber: 30, // 分成20个小分隔
                              hoverAnimation: true,
                              axisTick: {
                                show: false
                              },
                              splitLine: {
                                length: 12,
                                lineStyle: {
                                  width: 5,
                                  color: 'rgb(24, 48, 63)'
                                }
                              },
                              axisLabel: {
                                show: false
                              },
                              pointer: {
                                show: false
                              },
                              axisLine: {
                                lineStyle: {
                                  opacity: 0
                                }
                              },
                              detail: {
                                show: false
                              }
                            },
                            {
                              name: '',
                              type: 'gauge',
                              radius: '120%', //  显示成一个环形 // 和占比环重合
                              center: ['50%', '50%'],
                              startAngle: 270,
                              endAngle: 90,
                              splitNumber: 15, // 分成20个小分隔
                              hoverAnimation: true,
                              axisTick: {
                                show: false
                              },
                              splitLine: {
                                length: 12,
                                lineStyle: {
                                  width: 5,
                                  color: 'rgb(199, 239, 255)'
                                }
                              },
                              axisLabel: {
                                show: false
                              },
                              pointer: {
                                show: false
                              },
                              axisLine: {
                                lineStyle: {
                                  opacity: 0
                                }
                              },
                              detail: {
                                show: false
                              },
                              
                            },
                          //   外圆线
                            {
                              type: 'pie',
                              radius: ['100%', '98%'],
                              center: ['50%', '50%'],
                              hoverAnimation: false, // 鼠标移入变大
                              startAngle: 225,
                              labelLine: {
                                show: false
                              },
                              label: {
                                position: 'center'
                              },
                              data: [100],
                              color: ['rgba(255,255,255,.2)']
                            }
                          ]
                        }
                    },
                ]
            },
            // 
            // 右边
            // 
            // 停机数据
            downtimeData:{
              name:'停机数据',
              content:[
                {
                  title:'非计划停机次数',
                  res:12
                },
                {
                  title:'非计划停运率',
                  outageRate:'',
                  option: {
                    grid: {
                        top: '20%',
                        left: '0%',
                        right: '0%',
                        bottom: '20%',
                        gridIndex: 1,
                    },
                    tooltip: [{
                        show: false
                    }],
                    xAxis: {
                        type: 'value',
                        axisLine: {
                            show: false,
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: 'rgba(255,255,255,1)'
                            }
                        },
                        axisLabel: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        },
                        max: 'dataMax'
                    },
                    yAxis: {
                        show: false,
                        type: 'category',
                        splitLine: {
                            show: false,
                        },
                        axisLine: {
                            show: false,
                            onZero:false
                        },
                        axisLabel: {
                            show: true,
                            interval: 0,
                            //margin: '-210',
                            align: 'center',
                            textStyle: {
                                color: '#fff',
                                fontSize: 14
                            },
                        },
                        axisTick: {
                            show: false
                        },
                    },
                    series: [{
                        name: '真实值',
                        type: 'pictorialBar',
                        barWidth: '10%',
                        symbol: 'circle',
                        symbolRepeat: 'true',
                        symbolMargin: '80%',
                        symbolSize: [5, 5],
                        symbolRepeat: true,
                        barMinHeight: 1,
                        barMinWidth: 1,
                        itemStyle: {
                            normal: {
                                //borderRadius: [10,10],
                                color: '#155CFA',
                                //barBorderRadius: 2
                            }
                        },
                        label: {
                            normal: {
                                show: false,
                            }
                        },
                        z: 10,
                        data:[5]
                    },{
                        name: '背景条',
                        type: 'pictorialBar',
                        barWidth: '10%',
                        symbol: 'circle',
                        symbolRepeat: 'true',
                        symbolMargin: '80%',
                        symbolSize: [5, 5],
                        symbolRepeat: true,
                        barMinHeight: 1,
                        barMinWidth: 1,
                        itemStyle: {
                            normal: {
                              color: 'rgba(21,92,250,0.1)',
                            }
                        },
                        z: 0,
                        data:[10]
                    },{
                        name: '辅助值',
                        type: 'pictorialBar',
                        barWidth: '10%',
                        symbol: 'circle',
                        symbolRepeat: 'true',
                        symbolMargin: '80%',
                        symbolSize: [5, 5],
                        symbolRepeat: true,
                        barMinHeight: 1,
                        barMinWidth: 1,
                        itemStyle: {
                            normal: {
                                //borderRadius: [10,10],
                                 color:['#F7A899']
                                //barBorderRadius: 2
                            }
                        },
                        label: {
                            normal: {
                                show: false,
                            }
                        },
                        z: 5,
                        data:[]
                    }]
                }
                },
                {
                  title:'自动开停机成功运率',
                  outageRate:'',
                  option: {
                    grid: {
                        top: '20%',
                        left: '0%',
                        right: '0%',
                        bottom: '20%',
                        gridIndex: 1,
                    },
                    tooltip: [{
                        show: false
                    }],
                    xAxis: {
                        type: 'value',
                        axisLine: {
                            show: false,
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: 'rgba(255,255,255,1)'
                            }
                        },
                        axisLabel: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        },
                        max: 'dataMax'
                    },
                    yAxis: {
                        show: false,
                        type: 'category',
                        splitLine: {
                            show: false,
                        },
                        axisLine: {
                            show: false,
                            onZero:false
                        },
                        axisLabel: {
                            show: true,
                            interval: 0,
                            //margin: '-210',
                            align: 'center',
                            textStyle: {
                                color: '#fff',
                                fontSize: 14
                            },
                        },
                        axisTick: {
                            show: false
                        },
                    },
                    series: [{
                        name: '真实值',
                        type: 'pictorialBar',
                        barWidth: '10%',
                        symbol: 'circle',
                        symbolRepeat: 'true',
                        symbolMargin: '80%',
                        symbolSize: [5, 5],
                        symbolRepeat: true,
                        barMinHeight: 1,
                        barMinWidth: 1,
                        itemStyle: {
                            normal: {
                                //borderRadius: [10,10],
                                color: '#155CFA',
                                //barBorderRadius: 2
                            }
                        },
                        label: {
                            normal: {
                                show: false,
                            }
                        },
                        z: 10,
                        data:[2]
                    },{
                        name: '背景条',
                        type: 'pictorialBar',
                        barWidth: '10%',
                        symbol: 'circle',
                        symbolRepeat: 'true',
                        symbolMargin: '80%',
                        symbolSize: [5, 5],
                        symbolRepeat: true,
                        barMinHeight: 1,
                        barMinWidth: 1,
                        itemStyle: {
                            normal: {
                              color: 'rgba(21,92,250,0.1)',
                            }
                        },
                        z: 0,
                        data:[10]
                    },{
                        name: '辅助值',
                        type: 'pictorialBar',
                        barWidth: '10%',
                        symbol: 'circle',
                        symbolRepeat: 'true',
                        symbolMargin: '80%',
                        symbolSize: [5, 5],
                        symbolRepeat: true,
                        barMinHeight: 1,
                        barMinWidth: 1,
                        itemStyle: {
                            normal: {
                                //borderRadius: [10,10],
                                 color:['#F7A899']
                                //barBorderRadius: 2
                            }
                        },
                        label: {
                            normal: {
                                show: false,
                            }
                        },
                        z: 5,
                        data:[]
                    }]
                }
                },
              ]
            },
            // 可用系数
            availabilityFactor:{
              name:'可用系数',
              option:{
                title: {
                    
                    top: '47%',
                    textAlign: 'center',
                    left: '50%',
                    textStyle: {
                        color: '#5fb3ff',
                        fontSize: 32,
                        fontWeight: '600',
                    },
                },
                        legend: {
                  orient: 'horizontal',
                  left: '50%',
                  top:-3,
                  itemWidth:5,
                  itemHeight:5,
                  textStyle: {
                    fontSize:10,
                          color: '#FFFFFF',
                        },
                },
                series: [
                  {
                    name: '可用小时',
                    type: 'pie',
                    clockWise: false,
                    hoverAnimation: false,
                    radius: ['95%', '90%'],
                    center: ['50%', '50%'],
                    label: {
                        show: false,
                    },
                    itemStyle: {
                      color: {
                          "x": 0,
                          "y": 0,
                          "x2": 1,
                          "y2": 0,
                          "type": "linear",
                          "global": false,
                          "colorStops": [{
                              "offset": 0,
                              "color": "#00f5f1"
                          },{
                            offset: 0.9,
                            color: '#00f5f1',
                          }, {
                              "offset": 1,
                              "color": "rgba(0, 0, 0, 0)"
                          }]
                      }
                    },
                    data: [
                        {
                            value: 150,
                            name: '可用小时',
                        },
                        {
                          // 200-50
                            value: 50,
                            name: '',
                            itemStyle: {
                                color: 'rgba(255,255,255, .0)',
                            },
                        },
                    ],
                  },
                  {
                    name: '计划停运小时',
                    type: 'pie',
                    clockWise: false,
                    hoverAnimation: false,
                    radius: ['75%', '70%'],
                    center: ['50%', '50%'],
                    label: {
                        show: false,
                    },
                    itemStyle: {
                      color: {
                          "x": 0,
                          "y": 0,
                          "x2": 1,
                          "y2": 0,
                          "type": "linear",
                          "global": false,
                          "colorStops": [{
                              "offset": 0,
                              "color": "#00ff7e"
                          },{
                            offset: 0.9,
                            color: '#00ff7e',
                          }, {
                              "offset": 1,
                              "color": "rgba(0, 0, 0, 0)"
                          }]
                      }
                    },
                    data: [
                        {
                            value: 150,
                            name: '计划停运小时',
                        },
                        {
                          // 200-50
                            value: 50,
                            name: '',
                            itemStyle: {
                                color: 'rgba(255,255,255, .0)',
                            },
                        },
                    ],
                  },
                  {
                    name: '非计划停运小时',
                    type: 'pie',
                    clockWise: false,
                    hoverAnimation: false,
                    radius: ['55%', '50%'],
                    center: ['50%', '50%'],
                    label: {
                        show: false,
                    },
                    itemStyle: {
                      color: {
                          "x": 0,
                          "y": 0,
                          "x2": 1,
                          "y2": 0,
                          "type": "linear",
                          "global": false,
                          "colorStops": [{
                              "offset": 0,
                              "color": "#ff7723"
                          },{
                            offset: 0.9,
                            color: '#ff7723',
                          }, {
                              "offset": 1,
                              "color": "rgba(0, 0, 0, 0)"
                          }]
                      }
                    },
                    data: [
                        {
                            value: 150,
                            name: '非计划停运小时',
                        },
                        {
                          // 200-50
                            value: 50,
                            name: '',
                            itemStyle: {
                                color: 'rgba(255,255,255, .0)',
                            },
                        },
                    ],
                  },
                  {
                    type: 'pie',
                    zlevel: 3,
                    silent: true,
                    radius: ['35%', '30%'],
                    center: ['50%', '50%'],
                    label: {
                        normal: {
                            show: false
                        },
                    },
                    labelLine: {
                        normal: {
                            show: false
                        }
                    },
                    data: (function(){
                        let dataArr = [];
                        let total = 100;
                        let istrue = true;
                        let datevalue = 50 / total;
                        for (var i = 0; i < 36; i++) {
                            if (i % 2 === 0) {
                                if(istrue){
                                  dataArr.push({
                                    value: 2.5,
                                    itemStyle: {
                                        normal: {
                                            color: "#2d3237",
                                            borderWidth: 2,
                                            borderColor: "#2d3237",
                                            // borderRadius:[12,12,12,12]
                                        },
                                    }
                                  })
                                  istrue= false;
                                }else{
                                  dataArr.push({
                                    value: 2.5,
                                    itemStyle: {
                                        normal: {
                                            color: "#8d9093",
                                            borderWidth: 2,
                                            borderColor: "#8d9093",
                                            // borderRadius:[12,12,12,12]
                                        },
                                    }
                                  })
                                  istrue = true
                                }
                            } else {
                                dataArr.push({
                                    value: 3,
                                    itemStyle: {
                                        normal: {
                                            color: "rgba(0,0,0,0)",
                                            borderWidth: 0,
                                            borderColor: "rgba(0,0,0,0)"
                                        }
                                    }
                                })
                            }
                   
                        }
                        return dataArr
                    })()
                }
                ],
            }
            }
        }
    },
    actions: {
      res1() {
        this.downtimeData.content[1].outageRate =  (this.downtimeData.content[1].option.series[0].data[0] / this.downtimeData.content[1].option.series[1].data[0] )*100+ '%'
      },
      res2() {
        this.downtimeData.content[2].outageRate =  (this.downtimeData.content[2].option.series[0].data[0] / this.downtimeData.content[2].option.series[1].data[0] )*100+ '%'
      },
    }
})
export default useStore